module.exports = __webpack_public_path__ + "img/logo-white.de25cef8.svg";